import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './styles/tailwind.css';
import App from './App';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
// Build trigger Wed Oct 29 01:43:46 AM +04 2025
// Deploy trigger 1761688413
